import { createReducer } from "@reduxjs/toolkit";
import type { UploadState } from "@redux/state/shared-types";
import { resetUploadResume, uploadResume } from "./upload-resume";

const initialState: UploadState = { processing: "idle", url: null };

export const uploadResumeReducer = createReducer<UploadState>(initialState, builder => {
  builder.addCase(uploadResume.fulfilled, (state, { payload }) => {
    return {
      ...state,
      url: payload,
      processing: "success",
    };
  });
  builder.addCase(uploadResume.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(uploadResume.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUploadResume, () => {
    return initialState;
  });
});
